import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import styles from './title.styl'

export default class Title extends Component {
  static propTypes = {
    children: PropTypes.any,
    h1: PropTypes.bool,
    h2: PropTypes.bool,
    h3: PropTypes.bool,
    h4: PropTypes.bool,
    h5: PropTypes.bool,
    h6: PropTypes.bool,
    defaultColor: PropTypes.bool,
    style: PropTypes.object,
    colorClass: PropTypes.string,
    hasOverviewHeading: PropTypes.bool,
    className: PropTypes.string,
    intlKey: PropTypes.string,
    withIcon: PropTypes.bool,
    bold: PropTypes.bool
  }

  renderContent = () => {
    const { intlKey, children } = this.props

    if (intlKey) {
      return (
        <FormattedMessage
          id={intlKey}
          defaultMessage={typeof children === 'string' ? children : ''}
        />
      )
    }
    return children
  }

  render() {
    const {
      h1,
      h2,
      h3,
      h4,
      h5,
      h6,
      className,
      style,
      withIcon,
      defaultColor,
      colorClass,
      bold,
      hasOverviewHeading
    } = this.props
    const classNames = [styles.title, styles[colorClass], className]

    bold && classNames.push(styles.bold)
    defaultColor && classNames.push(styles.defaultColor)
    withIcon && classNames.push(styles.withIcon)
    hasOverviewHeading && classNames.push(styles.overviewHeading)

    if (h1) {
      return (
        <h1 className={classNames.join(' ')} style={style}>
          {this.renderContent()}
        </h1>
      )
    }
    if (h2) {
      return (
        <h2 className={classNames.join(' ')} style={style}>
          {this.renderContent()}
        </h2>
      )
    }
    if (h3) {
      return (
        <h3 className={classNames.join(' ')} style={style}>
          {this.renderContent()}
        </h3>
      )
    }
    if (h4) {
      return (
        <h4 className={classNames.join(' ')} style={style}>
          {this.renderContent()}
        </h4>
      )
    }
    if (h5) {
      return (
        <h5 className={classNames.join(' ')} style={style}>
          {this.renderContent()}
        </h5>
      )
    }
    if (h6) {
      return (
        <h6 className={classNames.join(' ')} style={style}>
          {this.renderContent()}
        </h6>
      )
    }

    return null
  }
}
